"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonContainer = exports.Content = exports.ContentContainer = void 0;
const framer_motion_1 = require("framer-motion");
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.ContentContainer = (0, styled_1.default)(framer_motion_1.motion.div) `
  border-width: 0 ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_width')}
    ${(0, ui_theme_1.fromTheme)('border_width')};
  border-style: ${(0, ui_theme_1.fromTheme)('border_style')};
  border-color: ${(0, ui_theme_1.fromTheme)('color_border')};
  height: auto;
  background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
`;
exports.Content = (0, styled_1.default)('div') `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  &&& td,
  &&& th {
    text-align: left;
  }
`;
exports.ButtonContainer = (0, styled_1.default)(framer_motion_1.motion.div) `
  background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
  border-top: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  & button {
    width: 100%;
  }
`;
//# sourceMappingURL=ProviderTabs.styles.js.map